import React from 'react';
import PropTypes from 'prop-types';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import InputErrors from 'components/InputErrors.jsx';
import classnames from 'classnames';
import { convertHtmlToRawText, removeBreakline } from 'modules/utils/text';
import { Text } from 'components/ui';
import useI18n from 'hooks/I18n/useI18n';

const WysiwygEditor = props => {
    const {
        content,
        editContent,
        disabled,
        showErrors,
        errors,
        placeholder,
        removeLink,
        maxLength,
        rows,
    } = props;

    const { trans } = useI18n();
    const countCharacters = removeBreakline(convertHtmlToRawText(content)).length;
    return (
        <React.Fragment>
            <div
                className={classnames({
                    'fa-input fa-input--error fa-input--block': showErrors,
                    'fa-input--disabled': disabled,
                })}
                style={{ padding: 0 }}
            >
                <CKEditor
                    editor={ClassicEditor}
                    data={content}
                    config={{
                        removePlugins: [
                            'CKFinderUploadAdapter',
                            'CKFinder',
                            'EasyImage',
                            'Image',
                            'ImageCaption',
                            'ImageStyle',
                            'ImageToolbar',
                            'ImageUpload',
                            'MediaEmbed',
                        ],
                        toolbar: [
                            'bold',
                            'italic',
                            removeLink ? '' : 'link',
                            'bulletedList',
                            'numberedList',
                            '|',
                            'undo',
                            'redo',
                        ],
                        placeholder,
                    }}
                    onChange={(_, editor) => {
                        const data = editor.getData();
                        editContent('content', data);
                    }}
                    disabled={disabled}
                    onReady={editor => {
                        if (rows) {
                            editor.editing.view.change(writer => {
                                writer.setStyle(
                                    'max-height',
                                    `${21 * rows + 38}px`,
                                    editor.editing.view.document.getRoot()
                                );
                            });
                        }
                    }}
                />
            </div>
            {maxLength ? (
                <Text
                    className="u-right"
                    color={countCharacters > maxLength ? 'danger' : 'info'}
                    size="small"
                >
                    {`${countCharacters}/${trans('global.chars.maxLength', {
                        '%maxLength%': maxLength,
                    })}`}
                </Text>
            ) : null}
            <InputErrors isVisible={showErrors} clientErrors={errors} />
        </React.Fragment>
    );
};

WysiwygEditor.propTypes = {
    content: PropTypes.string,
    editContent: PropTypes.func,
    disabled: PropTypes.bool,
    showErrors: PropTypes.bool,
    removeLink: PropTypes.bool,
    errors: PropTypes.array,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    rows: PropTypes.number,
};

export default WysiwygEditor;
